import { useEffect, useRef } from 'react';

/**
 * A custom hook adding adn removing eventListener on provided element.
 *
 * @param eventName - Event to listen to.
 * @param handler - A handler callback.
 * @param element - Optional element to listen the event on. Fallbacks to `window`.
 */
export const useEventListener = (
    eventName: string,
    handler: (event?: Event) => void,
    element: HTMLElement | typeof window = window
) => {
    const savedHandler = useRef<typeof handler>();

    useEffect(() => {
        savedHandler.current = handler;
    }, [handler]);

    useEffect(() => {
        const eventListener = (event: Event) =>
            savedHandler.current ? savedHandler.current(event) : null;

        element.addEventListener(eventName, eventListener);
        return () => {
            element.removeEventListener(eventName, eventListener);
        };
    }, [eventName, element]);
};
